<template>
    <div class="c-opinions-list__item">
      <article class="c-opinion-box">
        <div class="c-opinion-box__cols">
          <div class="c-opinion-box__col c-opinion-box__col--sidebar">
            <c-stars :rating="review.rating" />
            <p class="c-label c-label--default" v-if="review.purchase">
              <span class="o-ico o-ico--confirm o-ico--s">
                  <svg>
                    <use xlink:href="#svg-icon-confirmed"></use>
                  </svg>
              </span>
              <span class="c-label--thin">
                Potwierdzony zakup
              </span>
            </p>
          </div>
          <div class="c-opinion-box__col c-opinion-box__col--main">
            <p class="c-opinion-box__title">
              {{review.body}}
            </p>
            <div class="c-opinion-box__info">
              <div class="c-opinion-box__author">{{review.reviewer}}</div>
            </div>
            <div class="c-opinion-box__reaction">
              Przydatna opinia?
                <a class="c-opinion-box__reactionButton c-opinion-box__reactionButton--like" v-on:click="respondToReview(true)"
                  v-bind:class="{ 'c-opinion-box__reactionButton--processing' : processing }">
                  <svg>
                    <use xlink:href="#svg-icon-like"></use>
                  </svg>
                  ({{review.likesAmount ? review.likesAmount : 0}})
                </a>
                <a class="c-opinion-box__reactionButton c-opinion-box__reactionButton c-opinion-box__reactionButton--dislike"  v-on:click="respondToReview(false)"
                v-bind:class="{ 'c-opinion-box__reactionButton--processing' : processing }">
                  <svg>
                    <use xlink:href="#svg-icon-dislike"></use>
                  </svg>
                  ({{review.dislikesAmount ? review.dislikesAmount : 0}})
                </a>
                <p class="c-opinion-box__reactionError" v-if="errorMessage">{{errorMessage}}</p>
            </div>
            <div v-if="review.adminAnswer" class="c-opinion-box__answer">
                <p class="c-opinion-box__answerHeader">
                  Odpowiedź {{review.adminName ? 'od ' + review.adminName : ' '}}
                </p>
                {{review.adminAnswer}}
            </div>
          </div>
        </div>
      </article>
    </div>
</template>
<script>
import Rating from '@/components/Rating.vue'
import CStars from '@/components/CStars.vue'
import {formatTimeAgo} from '@/shared/datetime'
import {addReviewResponse} from '@/api/productReviews/addReviewResponse'

export default {
  props: ['review', 'productName'],

  data () {
    return { errorMessage: false, processing: false }
  },

  components: {
    CStars,
    Rating
  },

  methods: {
    respondToReview (isResponsePositive) {
      this.processing = true
      this.errorMessage = ''
      addReviewResponse(this.review.id, isResponsePositive)
        .then(result => {
          if (result.success) {
            this.review.likesAmount = result.likesAmount
            this.review.dislikesAmount = result.dislikesAmount
            this.errorMessage = null
          } else {
            this.errorMessage = 'Musisz się zalogować aby ocenić recenzję.'
          }
        })
        .catch(() => {
          this.errorMessage = 'Wystąpił błąd.'
        }).finally(() => {
          this.processing = false
        })
    }
  },

  computed: {
    formattedCreatedAt () {
      return formatTimeAgo(this.review.createdAt)
    },
    formattedAdminAnswerAt () {
      return this.review.adminAnswerAt ? formatTimeAgo(this.review.adminAnswerAt) : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductPage/Review.vue